import {EmployeeRef} from "../../api/Model";
import {AssignedDesks} from "../../api/AssignedDeskStore";

export interface AssignedDeskCriteria {
    get ordinal(): number;

    get label(): string;

    get description(): string;

    hasAssignedDesk(
        employee: EmployeeRef,
        assignedDesks: AssignedDesks,
        visitCounts: Map<EmployeeRef['id'], number>,
        totalDays: number,
    ): boolean


    deskComment(shouldHaveDesk: boolean): string;
}

class AssignedDeskThresholdCriteria implements AssignedDeskCriteria {
    constructor(private readonly assignedDeskThresholdPercent: number) {
    }

    get ordinal(): number {
        return this.assignedDeskThresholdPercent;
    }

    get label(): string {
        return `${this.assignedDeskThresholdPercent}%`;
    }

    get description(): string {
        return `Recommended number of assigned desks in the neighbourhood if the threshold is ${this.assignedDeskThresholdPercent}% visits`;
    }

    hasAssignedDesk(
        employee: EmployeeRef,
        assignedDesks: AssignedDesks,
        visitCounts: Map<EmployeeRef['id'], number>,
        totalDays: number
    ): boolean {
        return totalDays > 0 ? (visitCounts.get(employee.id) || 0) * 100 / totalDays >= this.assignedDeskThresholdPercent : false;
    }

    deskComment(hasDesk: boolean): string {
        return hasDesk ? 'assigned desk recommended' : 'flex desk recommended';
    }
}

class AssignedInEnvoyCriteria implements AssignedDeskCriteria {
    get ordinal(): number {
        return 1000;
    }

    get label(): string {
        return 'Envoy';
    }

    get description(): string {
        return "Number of assigned desks in Envoy";
    }

    hasAssignedDesk(
        employee: EmployeeRef,
        assignedDesks: AssignedDesks,
        visitCounts: Map<EmployeeRef['id'], number>,
        totalDays: number
    ): boolean {
        return assignedDesks.desksOf(employee).length > 0;
    }

    deskComment(shouldHaveDesk: boolean): string {
        return shouldHaveDesk ? 'assigned desk in Envoy' : 'flex desk in Envoy';
    }
}

export const assignedDeskCriteria: Record<string, AssignedDeskCriteria> = {
    envoy: new AssignedInEnvoyCriteria(),
    100: new AssignedDeskThresholdCriteria(100),
    80: new AssignedDeskThresholdCriteria(80),
    60: new AssignedDeskThresholdCriteria(60),
    50: new AssignedDeskThresholdCriteria(50),
    40: new AssignedDeskThresholdCriteria(40),
    30: new AssignedDeskThresholdCriteria(30),
    20: new AssignedDeskThresholdCriteria(20),
}